import { Injectable } from '@angular/core';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class BadgeService {

  private _badge = new BehaviorSubject<number>(null);

  get badgeObs() {
    return this._badge.asObservable();
  }

  constructor(private badge: Badge) { }

  async get(){
    return await this.badge.get();
  }

  async init(){
    const value = await this.badge.get();
    this._badge.next(value);
  }

  async set(i: number){
    await this.badge.set(i);
    this._badge.next(i);
  }

  async increase(i: number){
    await this.badge.increase(i);
    this._badge.next(this._badge.getValue() + i);
  }

  async decrease(i: number){
    await this.badge.decrease(i);
    this._badge.next(this._badge.getValue() - i);
  }

  async clear(){
    await this.badge.clear();
    this._badge.next(0);
  }

}
